import React from "react";
import "./Footer.css";

const services = [
  "Rút thẻ nhanh chóng",
  "Quẹt thẻ 24/7",
  "Rút thẻ online",
  "Đáo rút thẻ 24h",
  "Rút thẻ tại nhà",
  "Cà thẻ uy tín",
];

const areas = [
  "Hà Nội",
  "TP. Hồ Chí Minh",
  "Đà Nẵng",
  "Hải Phòng",
  "Cần Thơ",
  "Toàn quốc 63 tỉnh",
];

const highlights = [
  "An toàn — thẻ không rời tay bạn",
  "Phí minh bạch — không phát sinh",
  "Có mặt nhanh — hỗ trợ 24/7",
  "Uy tín lâu năm — nhiều khách tin dùng",
];

export default function Footer() {
  return (
    <footer className="footer-orange">
      <div className="footer-orange__container">
        <div className="footer-orange__top">
          <div className="footer-orange__hero">
            <p className="footer-orange__subtitle">
              Phí minh bạch • Bảo mật tuyệt đối • Hỗ trợ 24/7 • Phục vụ linh
              hoạt
            </p>
          </div>
        </div>

        <div className="footer-orange__divider" />

        <div className="footer-orange__grid">
          <div className="footer-orange__col">
            <h3 className="footer-orange__heading">Liên hệ</h3>

            <div className="footer-orange__contact-list">
              <div className="footer-orange__contact-item">
                <div className="footer-orange__icon">📞</div>
                <div>
                  <p className="footer-orange__label">Hotline 24/7</p>
                  <a
                    onClick={() => {
                      window.dataLayer = window.dataLayer || [];

                      window.dataLayer.push({
                        event: "goi",
                      });
                    }}
                    href="tel:0941395019"
                    className="footer-orange__link"
                  >
                    0941 395 019
                  </a>
                </div>
              </div>

              <div className="footer-orange__contact-item">
                <div className="footer-orange__icon">✉️</div>
                <div>
                  <p className="footer-orange__label">Email</p>
                  <a
                    href="mailto:hotro@rutthepro.vn"
                    className="footer-orange__link"
                  >
                    hotro@ruttienthehanoi24h.site
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-orange__col">
            <h3 className="footer-orange__heading">Dịch vụ</h3>
            <ul className="footer-orange__list">
              {services.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>

          <div className="footer-orange__col">
            <h3 className="footer-orange__heading">Khu vực</h3>
            <ul className="footer-orange__list">
              {areas.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        </div>

        <div className="footer-orange__badges">
          {highlights.map((item) => (
            <div key={item} className="footer-orange__badge">
              ✓ {item}
            </div>
          ))}
        </div>
      </div>

      <div className="footer-orange__bottom">
        <div className="footer-orange__bottom-inner">
          <div className="footer-orange__copyright">
            © 2025 ruttientindung3s.com · Dịch vụ hỗ trợ giao dịch linh hoạt
          </div>

          <div className="footer-orange__bottom-links">
            <a href="/bao-mat">Bảo mật</a>
            <a href="/dieu-khoan">Điều khoản</a>
            <a href="/cam-ket">Cam kết</a>
            <a href="/lien-he">Liên hệ</a>
          </div>

          <div className="footer-orange__status">● Đang hỗ trợ 24/7</div>
        </div>
      </div>
    </footer>
  );
}
